export default "__VITE_ASSET__dc5d5a48__"